export default {
  'exhibitor_invitation_record': '邀请函管理',
  'exhibitor_invitation_record2': '邀请函管理(已发送列表)',
  'only_visitors': '只有通过自己邀请函注册的客商，才可加入客户池',
  'join_the_customer_pool': '加入客户池',
  'audience_name': '客商姓名',
  'email': '邮箱',
  'status': '通过邀请函登录/注册',
  'invitation_date': '邀请日期',
  'register_date': '登录/注册日期',
  'registered': '已注册',
  'unregistered': '未注册'
}